import { createContext, useContext, ReactNode, FC } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

type OrganizationsContextType = AdminResponses.Organization[]

export const OrganizationsContext = createContext<
  OrganizationsContextType | undefined
>(undefined)

export const useOrganizationsContext = () => {
  const context = useContext(OrganizationsContext)
  if (!context) {
    throw new Error(
      "useOrganizationsContext must be used within a OrganizationsProvider"
    )
  }
  return context
}

export const OrganizationsProvider: FC<{
  children: ReactNode
  organizations: OrganizationsContextType
}> = ({ children, organizations }) => {
  return (
    <OrganizationsContext.Provider value={organizations}>
      {children}
    </OrganizationsContext.Provider>
  )
}
